/**
 * A JANELA do Progresso no cartão flutuante (§5.1): no máximo `maxVisiveis`
 * etapas a partir da atual (a primeira não encerrada); as concluídas antes
 * dela saem da lista e viram só uma contagem ("✓ 4 concluídas"). Etapa que
 * FALHOU nunca some. Sem limite (a bolha do plano) devolve tudo.
 *
 * Pura: `janelaDoProgresso(passos, 3)` → `{ visiveis, concluidasOcultas }`.
 */
import { STATUS_DO_PASSO } from './progresso-do-turno'

const STATUS_ATUAIS = new Set([STATUS_DO_PASSO.EM_ANDAMENTO, STATUS_DO_PASSO.PENDENTE])

function indiceDaEtapaAtual(passos) {
  for (let i = 0; i < passos.length; i += 1) {
    if (STATUS_ATUAIS.has(passos[i].status)) return i
  }
  return -1
}

export function janelaDoProgresso(passos, maxVisiveis) {
  const lista = passos || []
  const limite = Number(maxVisiveis) || 0
  if (!limite || lista.length <= limite) return { visiveis: lista, concluidasOcultas: 0 }

  const ultimoInicio = lista.length - limite
  const atual = indiceDaEtapaAtual(lista)
  const inicio = atual === -1 ? ultimoInicio : Math.min(atual, ultimoInicio)
  const fim = inicio + limite
  const visiveis = lista.filter((passo, i) => (i >= inicio && i < fim) || passo.status === STATUS_DO_PASSO.FALHOU)
  const falhasAntes = lista.slice(0, inicio).filter((passo) => passo.status === STATUS_DO_PASSO.FALHOU)
  return { visiveis, concluidasOcultas: inicio - falhasAntes.length }
}
